import { Components, Theme } from '@mui/material/styles';

export default function MuiCard(theme: Theme): Components['MuiCard'] {
  return {
    styleOverrides: {
      root: {
        borderRadius: 0,
        boxShadow: 'none',
      },
    },
  };
}
